import axios from 'axios';
import Common from './Common';
export default {
    getAll(layer, user) {
        return axios.get(Common.api + 'get-requests/' + user + '/' + layer);
    },
    getRequestResponse(id) {
        return axios.get(Common.api + 'get-requests-response/' + id);
    },
    getRequestDetail(id, user) {
        return axios.get(Common.api + 'get-requests-details/' + id + '/' + user);
    },
    saveRequestDetail(data) {
        return axios.post(Common.api + 'post-requests-response', data);
    },
    update(id, data) {
        return axios.put(Common.api + 'seller-login' + id, data);
    },
    acceptResponse(data) {
        return axios.post(Common.api + 'accept-requests-response', data);
    },
    getFilteredRequests(data) {
        return axios.post(Common.api + 'get-filtered-requests', data);
    },
    getAllpending(layer, user) {
        return axios.get(Common.api + 'get-bulletin/' + user + '/' + layer);
    },
    acceptRequestSeller(data) {
        return axios.post(Common.api + 'accept-requests-response', data);
    },
    rejectRequestSeller(data) {
        return axios.post(Common.api + 'accept-requests-response', data);
    },
    executeAcceptance(data) {
        return axios.post(Common.api + 'execute-response-acceptance', data);
    },
    receiveService(data) {
        return axios.post(Common.api + 'acknowledge-service-receival', data);
    },
    sendService(data) {
        return axios.post(Common.api + 'send-service', data);
    },
    getMyPoints(id) {
        return axios.get(Common.api + 'get-av-points/' + id);
    }
}